module.exports = __webpack_public_path__ + "static/img/two_pic@2x.bbb827e6.png";